import * as Yup from "yup";
import i18n from "../../i18n";

const schema = Yup.object({
  email: Yup.string()
    .email(i18n.t("signIn.errorMessages.invalidEmail"))
    .required(i18n.t("signIn.errorMessages.missingEmail")),
  password: Yup.string().required(
    i18n.t("signIn.errorMessages.missingPassword"),
  ),
});

export default schema;
